<section class="asset-detail glass-panel">
  <wn-admin-back-link link="/assets" [label]="'ASSET_DETAIL.BACK' | translate"></wn-admin-back-link>
  @if (loadError(); as err) {
    <p class="asset-detail__error" role="alert">{{ err }}</p>
  } @else if (loading()) {
    <p class="asset-detail__status" role="status">{{ 'ASSET_DETAIL.LOADING' | translate }}</p>
  } @else if (asset(); as a) {
    <p class="eyebrow">{{ 'ASSET_DETAIL.EYEBROW' | translate }}</p>
    <h1>{{ title(a) }}</h1>
    <p class="lede">{{ a.assetCode }} · {{ categoryTitle(a) }}</p>

    <div class="asset-detail__toolbar">
      <a class="asset-detail__link" [routerLink]="['/assets', a.id, 'edit']">{{ 'ASSET_DETAIL.EDIT' | translate }}</a>
      <button type="button" pButton [outlined]="true" [disabled]="actionLoading()" (click)="runAssetAction('maintenance')">
        {{ 'ASSETS.SEND_MAINTENANCE' | translate }}
      </button>
      <button type="button" pButton [outlined]="true" [disabled]="actionLoading()" (click)="lossMode.set('damaged')">
        {{ 'ASSETS.MARK_DAMAGED' | translate }}
      </button>
      <button type="button" pButton [outlined]="true" [disabled]="actionLoading()" (click)="lossMode.set('lost')">
        {{ 'ASSETS.MARK_LOST' | translate }}
      </button>
    </div>

    @if (lossMode(); as mode) {
      <app-asset-loss-dialog
        [mode]="mode"
        [asset]="{ purchaseCost: a.purchaseCost, assignedUserId: a.currentAssignedUserId, assignedUserName: a.currentAssignedUserFullName }"
        (confirmed)="confirmLoss($event)"
        (closed)="lossMode.set(null)"
      />
    }

    @if (actionError(); as err) {
      <p class="asset-detail__error" role="alert">{{ err }}</p>
    }

    <section class="wn-card">
      <div class="wn-card__head">
        <strong>{{ 'ASSET_DETAIL.EYEBROW' | translate }}</strong>
      </div>
      <div class="wn-card__body">
        <dl class="asset-detail__grid">
          <div class="asset-detail__row"><dt>{{ 'ASSETS.CODE' | translate }}</dt><dd>{{ a.assetCode }}</dd></div>
          <div class="asset-detail__row"><dt>{{ 'ASSETS.CATEGORY' | translate }}</dt><dd>{{ categoryTitle(a) }}</dd></div>
          <div class="asset-detail__row"><dt>{{ 'ASSETS.SERIAL_NUMBER' | translate }}</dt><dd>{{ a.serialNumber || ('PROFILE.NOT_SET' | translate) }}</dd></div>
          <div class="asset-detail__row"><dt>{{ 'ASSETS.STATUS_LABEL' | translate }}</dt><dd><wn-status-chip [label]="statusLabel(a.status) | translate" /></dd></div>
          <div class="asset-detail__row"><dt>{{ 'ASSETS.BRANCH' | translate }}</dt><dd>{{ branchTitle(a) }}</dd></div>
          <div class="asset-detail__row"><dt>{{ 'ASSETS.ASSIGNED_TO' | translate }}</dt><dd>{{ a.currentAssignedUserFullName || ('PROFILE.NOT_SET' | translate) }}</dd></div>
          <div class="asset-detail__row"><dt>{{ 'ASSETS.PURCHASE_DATE' | translate }}</dt><dd>{{ a.purchaseDate ? (a.purchaseDate | date: 'mediumDate':'UTC') : ('PROFILE.NOT_SET' | translate) }}</dd></div>
          <div class="asset-detail__row"><dt>{{ 'ASSETS.PURCHASE_COST' | translate }}</dt><dd>{{ a.purchaseCost ?? ('PROFILE.NOT_SET' | translate) }}</dd></div>
          <div class="asset-detail__row"><dt>{{ 'ASSETS.WARRANTY_EXPIRY' | translate }}</dt><dd>{{ a.warrantyExpiryDate ? (a.warrantyExpiryDate | date: 'mediumDate':'UTC') : ('PROFILE.NOT_SET' | translate) }}</dd></div>
          <div class="asset-detail__row asset-detail__row--wide"><dt>{{ 'ASSETS.NOTES' | translate }}</dt><dd>{{ a.notes || ('PROFILE.NOT_SET' | translate) }}</dd></div>
        </dl>
      </div>
    </section>

    <div class="asset-detail__panels">
      <form class="wn-card asset-detail__panel" [formGroup]="assignForm" (ngSubmit)="assign()" novalidate>
        <div class="wn-card__head">
          <strong>{{ 'ASSET_DETAIL.ASSIGN_TITLE' | translate }}</strong>
        </div>
        <div class="wn-card__body asset-detail__panel-body">
          <p>{{ 'ASSET_DETAIL.ASSIGN_LEDE' | translate }}</p>
          <label class="field">
            <span class="field__label">{{ 'ASSET_DETAIL.EMPLOYEE' | translate }}</span>
            <app-user-lookup-select
              formControlName="assignedToUserId"
              [placeholder]="'ASSET_DETAIL.SELECT_EMPLOYEE' | translate"
              [loadingLabel]="'EMPLOYEE_DOCUMENTS.LOADING_EMPLOYEES' | translate"
              [emptyLabel]="'EMPLOYEE_DOCUMENTS.NO_EMPLOYEE_MATCHES' | translate"
              [clearLabel]="'EMPLOYEE_DOCUMENTS.CLEAR_EMPLOYEE' | translate"
            />
          </label>
          <label class="field">
            <span class="field__label">{{ 'ASSET_DETAIL.EXPECTED_RETURN' | translate }}</span>
            <wn-date-picker formControlName="expectedReturnDate" [ariaLabel]="'ASSET_DETAIL.EXPECTED_RETURN' | translate"></wn-date-picker>
          </label>
          <label class="field">
            <span class="field__label">{{ 'ASSET_DETAIL.CONDITION_ON_ASSIGN' | translate }}</span>
            <input class="field__input" type="text" formControlName="conditionOnAssign" />
          </label>
          <label class="field field--wide">
            <span class="field__label">{{ 'ASSET_DETAIL.ADMIN_NOTES' | translate }}</span>
            <textarea class="field__input" rows="3" formControlName="adminNotes"></textarea>
          </label>
          <button type="submit" pButton [disabled]="actionLoading() || a.status !== 1">{{ 'ASSET_DETAIL.ASSIGN_ACTION' | translate }}</button>
        </div>
      </form>

      <form class="wn-card asset-detail__panel" [formGroup]="returnForm" (ngSubmit)="returnActiveAssignment()" novalidate>
        <div class="wn-card__head">
          <strong>{{ 'ASSET_DETAIL.RETURN_TITLE' | translate }}</strong>
        </div>
        <div class="wn-card__body asset-detail__panel-body">
          @if (activeAssignment(); as assignment) {
            <p>{{ 'ASSET_DETAIL.ACTIVE_ASSIGNMENT' | translate }}: {{ assignment.assignedToUserFullName || '-' }}</p>
          } @else {
            <p>{{ 'ASSET_DETAIL.NO_ACTIVE_ASSIGNMENT' | translate }}</p>
          }
          <label class="field">
            <span class="field__label">{{ 'ASSET_DETAIL.RESULT_STATUS' | translate }}</span>
            <select class="field__input" formControlName="resultingAssetStatus">
              @for (status of returnStatuses; track status) {
                <option [ngValue]="status">{{ statusLabel(status) | translate }}</option>
              }
            </select>
          </label>
          <label class="field">
            <span class="field__label">{{ 'ASSET_DETAIL.CONDITION_ON_RETURN' | translate }}</span>
            <input class="field__input" type="text" formControlName="conditionOnReturn" />
          </label>
          <label class="field field--wide">
            <span class="field__label">{{ 'ASSET_DETAIL.ADMIN_NOTES' | translate }}</span>
            <textarea class="field__input" rows="3" formControlName="adminNotes"></textarea>
          </label>
          <button type="submit" pButton [disabled]="actionLoading() || !activeAssignment()">{{ 'ASSET_DETAIL.RETURN_ACTION' | translate }}</button>
        </div>
      </form>

      <form class="wn-card asset-detail__panel" [formGroup]="maintenanceForm" (ngSubmit)="scheduleMaintenance()" novalidate>
        <div class="wn-card__head">
          <strong>{{ 'ASSET_DETAIL.MAINTENANCE_TITLE' | translate }}</strong>
        </div>
        <div class="wn-card__body asset-detail__panel-body">
          <p>{{ 'ASSET_DETAIL.MAINTENANCE_LEDE' | translate }}</p>
          <label class="field">
            <span class="field__label">{{ 'ASSETS.DATE' | translate }}</span>
            <wn-date-picker formControlName="maintenanceDate" [ariaLabel]="'ASSETS.DATE' | translate"></wn-date-picker>
          </label>
          <label class="field">
            <span class="field__label">{{ 'ASSETS.PROVIDER' | translate }}</span>
            <input class="field__input" type="text" formControlName="providerTitle" />
          </label>
          <label class="field">
            <span class="field__label">{{ 'ASSETS.COST' | translate }}</span>
            <input class="field__input" type="number" min="0" step="0.01" formControlName="cost" />
          </label>
          <label class="field field--wide">
            <span class="field__label">{{ 'ASSETS.DESCRIPTION' | translate }}</span>
            <textarea class="field__input" rows="3" formControlName="description"></textarea>
          </label>
          <button type="submit" pButton [disabled]="actionLoading()">{{ 'ASSET_DETAIL.SCHEDULE_MAINTENANCE' | translate }}</button>
        </div>
      </form>
    </div>

    <section class="wn-card asset-detail__section">
      <div class="wn-card__head">
        <strong>{{ 'ASSET_DETAIL.ASSIGNMENT_HISTORY' | translate }}</strong>
      </div>
      <div class="asset-detail__table-wrap">
        <table class="asset-detail__table">
          <thead><tr><th scope="col">{{ 'ASSET_DETAIL.EMPLOYEE' | translate }}</th><th scope="col">{{ 'ASSETS.ASSIGNED_AT' | translate }}</th><th scope="col">{{ 'ASSET_DETAIL.EXPECTED_RETURN' | translate }}</th><th scope="col">{{ 'COMMON.STATUS' | translate }}</th></tr></thead>
          <tbody>
            @for (row of a.assignmentHistory; track row.id) {
              <tr><td>{{ row.assignedToUserFullName || '-' }}</td><td>{{ row.assignedAt | date: 'mediumDate':'UTC' }}</td><td>{{ row.expectedReturnDate ? (row.expectedReturnDate | date: 'mediumDate':'UTC') : '-' }}</td><td>{{ assignmentStatusLabel(row.assignmentStatus) | translate }}</td></tr>
            } @empty {
              <tr><td colspan="4">{{ 'ASSET_DETAIL.NO_ASSIGNMENTS' | translate }}</td></tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <app-asset-charges-panel class="asset-detail__section" [assetId]="a.id" />

    <section class="wn-card asset-detail__section">
      <div class="wn-card__head">
        <strong>{{ 'ASSET_DETAIL.MAINTENANCE_HISTORY' | translate }}</strong>
      </div>
      <div class="asset-detail__table-wrap">
        <table class="asset-detail__table">
          <thead><tr><th scope="col">{{ 'ASSETS.DATE' | translate }}</th><th scope="col">{{ 'ASSETS.PROVIDER' | translate }}</th><th scope="col">{{ 'ASSETS.COST' | translate }}</th><th scope="col">{{ 'COMMON.STATUS' | translate }}</th></tr></thead>
          <tbody>
            @for (row of a.maintenanceHistory; track row.id) {
              <tr><td>{{ row.maintenanceDate | date: 'mediumDate':'UTC' }}</td><td>{{ row.providerTitle || '-' }}</td><td>{{ row.cost ?? '-' }}</td><td>{{ maintenanceStatusLabel(row.status) | translate }}</td></tr>
            } @empty {
              <tr><td colspan="4">{{ 'ASSET_DETAIL.NO_MAINTENANCE' | translate }}</td></tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  }
</section>
